import { gql, useQuery } from '@apollo/client';
import React, { useState } from 'react';
import CarList from "../../CarList";
import SeoLoader from "../../SeoLoader";
import { useLocation, useHistory } from 'react-router-dom';
import {makeStyles} from "@material-ui/core/styles/index";
import {blue} from "@material-ui/core/colors/index";
import {serverRootUrl} from "../../config";
import Carousel from "react-elastic-carousel";
import Flex from "../../Flex";
import Circle from "../../Circle";
import Typography from "@material-ui/core/Typography/Typography";
import useSeo from "../../Components/Seo/UseSeo";
import * as ReactGA from "react-ga";
import LeftColumn from "../../Components/Column/LeftColumn";
import FilterSelection from "../../Components/Filter/FilterSelection";
import FilterFormMobile from "../../Components/Filter/FilterFormMobile";
import {Pager} from "../../Components/List/Pager";
import Seo from "../../Seo";
import CarListHeader from "../../Components/Layout/CarListHeader";
import clsx from 'clsx';
import DefaultHeader from "../../Components/Layout/DefaultHeader";
import SortingWrapper from "../Filter/Sorting/SortingWrapper";
import Support from "../Support/Support";
import WarmUp from "../Ads/WarmUp/WarmUp";

const GET_LIST = gql`
  query($text:String, $filterOptions: [FilterOption]) {
        getList(searchInput: {text: $text, filterOptions: $filterOptions}) {
        minPrice
        maxPrice
        total
        items {
            sn
            image
            title
            year
            price
            off
            sold
            requestCode
            city
            state
            hint
            mileage
            analytics {
                hits
                dailyHits
                yesterdayHits
            }
        }
        seo {
            canonical
            path
            title
            metaDescription
            metaKeywords
            ogTitle
            ogDescription
            twTitle
            twDescription
            ogImage
            twImage
        }
        carAnalyticsSummary {
            hits
            dailyHits
            yesterdayHits
        }
     }
  }
`;

const useStyles = makeStyles((theme) => {
    return {
        wrapper: {
            flex: '0 0 calc(100% - 300px)',
            display: 'flex',
            alignContent: 'flex-start',
            flexWrap: 'wrap',
            boxSizing: 'border-box',
            ['@media (max-width:700px)']: {
                flex: '0 0 100%',
            }
        },
        noColumn: {
            flex: '0 0 100%',
        },
        avatar: {
            backgroundColor: blue[500],
        },
        h1: {
            fontSize: '1rem',
            fontWeight: 'normal',
            margin:0
        },
        carousel: {
            position: 'relative'
        },
        media: {
            height: 200,
            cursor: 'pointer',
            position: 'relative',
            width: '100%',
            [theme.breakpoints.up('xs')]: {
                height: 120,
            },
            [theme.breakpoints.up('sm')]: {
                height: 200,
            },
        },
        image: {
            width: '100%',
            marginTop: '-10%'
        },
        imageContainer: {
            marginRight: 1
        },
        latestOffers: {
            margin: '15px 0 10px 0',
        },
        latestOffersMobile: {
            margin: '15px 0 10px 10px',
        },
        header: {
            maxHeight: 72,
            width: '100%'
        },
        contentHeader: {
            fontSize: '1.25rem',
            fontWeight: 'normal',
            marginTop: 15,
            marginBottom: 10,
            marginLeft: 10,
            width: '100%',
        },
        description: {
            whiteSpace: 'pre-line',
            marginLeft: 10
        },
        summary: {
            fontSize: '.8rem',
            marginBottom: 5,
        }
    }});

export default function CarListPage(props) {

    const location = useLocation();
    const classes = useStyles();

    const [eParams, setEParams] = useState();
    const [imageIndex, setImageIndex] = React.useState(0);
    const [showFilter, setShowFilter] = React.useState();

    const filter = props.filter;

    const variables = {
        text: props.search,
        filterOptions: filter.params.filterOptions
    };

    const { loading, error, data, refetch } = useQuery(GET_LIST, {variables: variables});

    //needMoreCars = needMoreCars || data && data.getList.items.length < 18 && page === 0;

    const onEParams = data => {
        if (!eParams && data) {
            setEParams(data);
            if (data.filterOptions) {
                const asString = JSON.stringify(filter.params.filterOptions);
                //console.log(asString, data.filterOptions, asString !== data.filterOptions);

                if (asString !== data.filterOptions) {
                    filter.setLandingPageFilterOptions(data.filterOptions);
                    filter.dispatchFilter(false);
                }
            }

            ReactGA.event({
                category: 'User',
                action: 'landing_page',
                label: window.location.pathname
            });
        }
    };

    const handleExit = () => {
        window.location = '/';
    };

    const handleShowFilter = (value) => {
        if (showFilter !== value) {
            setShowFilter(value);
        }
    };

    const isLp = location.pathname !== '/';

    const header = eParams && eParams.header ? eParams.header : global.eParams ? global.eParams.header :  'Cars for Sale';
    const contentHeader = eParams && eParams.contentHeader ? eParams.contentHeader : global.eParams ? global.eParams.contentHeader :  null;
    const description = eParams && eParams.description ? eParams.description : global.eParams ? global.eParams.description :  null;
    const images = eParams && eParams.images ? eParams.images : global.eParams ? global.eParams.images :  [];
    let options = eParams && eParams.options ? eParams.options : global.eParams ? global.eParams.options : '';
    options = options ? options : '';

    let carousel;

    const isMobile = props.isMobile;

    const switchImage = (e) => {
        const edgeX = isMobile ? 0 : (window.innerWidth - 900)/2;
        const mouseX = e.clientX - edgeX;
        if (mouseX < 200) {
            prevImage();
        } else {
            nextImage();
        }
    };

    const prevImage = (e) => {
        if (imageIndex <= 0) {
            carousel.goTo(images.length - 1);
            setImageIndex(images.length - 1);
        } else {
            setImageIndex(imageIndex - 1);
            carousel.slidePrev();
        }
    };

    const nextImage = (e) => {
        if (imageIndex >= images.length - 1) {
            carousel.goTo(0);
            setImageIndex(0);
        } else {
            setImageIndex(imageIndex + 1);
            carousel.slideNext();
        }
    };

    const seo = useSeo(eParams);

    if (data && data.getList) {
        filter.setPriceRange(data.getList.minPrice, data.getList.maxPrice);
        filter.setTotal(data.getList.total);
        filter.dispatch();
    }

    filter.addDispatchCallback('lp', (newFilterOptions) => {
        if (refetch) {
            refetch({...variables, filterOptions: newFilterOptions});
        }
    });

    const hasSelection = props.filter.params.hasSelection;

    const sum = data && data.getList ? data && data.getList.carAnalyticsSummary : null;

    const sideContent = <>
        {sum ? <Typography className={classes.summary}>TDA: {sum.dailyHits} YDA: {sum.yesterdayHits}  TTL: {sum.hits}</Typography> : ''}
        <SortingWrapper filter={props.filter} isMobile={props.isMobile} user={props.user}/></>;

    return (
        <>
            {data && data.getList ? <Seo seo={data.getList.seo}/> : null}
            <CarListHeader filter={filter} isMobile={props.isMobile}
                           sideContent={hasSelection ? null : sideContent}/>
            {options.indexOf('no-column') === -1 ?
            <LeftColumn setReturnToItemRoute={props.setReturnToItemRoute}
                links={seo.links}
                options={options}
                isMobile={isMobile}
                isLp={true}
                filter={props.filter}
                hasFilter={true}
                text="Let me help you with your search!"
            /> : null}

            <div className={clsx(classes.wrapper, options.indexOf('no-cars') !== -1 ? classes.noColumn : null)}>
                {isLp && options.indexOf('no-seo') === -1 ? <SeoLoader url={location.pathname} onEParams={onEParams}/> : null}
                {images.length ?
                    <Carousel className={classes.carousel} showArrows={false} ref={ref => (carousel = ref)}
                              preventDefaultTouchmoveEvent={true}
                              enableAutoPlayenableAutoPlay={true}
                              enableSwipe={false}
                              itemsToShow={2}
                              renderPagination={({ pages, activePage, onClick }) => {
                                  return (
                                      <Flex isGallery={true}>
                                          {pages.map(page => {
                                              const isActivePage = activePage === page
                                              return (
                                                  <Circle
                                                      key={page}
                                                      onClick={switchImage}
                                                      active={isActivePage}
                                                  />
                                              )
                                          })}
                                      </Flex>
                                  )
                              }}>
                        {images.map(im =>
                            <div className={classes.media}>
                                <div className={classes.imageContainer}>
                                    <img className={classes.image} alt={im.description ? im.description : header} title={im.description ? im.description : header} src={serverRootUrl + '/' + im.image} onClick={switchImage}/>
                                </div>
                            </div>
                        )}

                    </Carousel> : null}
                {contentHeader ? <Typography className={classes.contentHeader} variant={'h2'}>{contentHeader}</Typography> : null}

                {description ? <Typography className={classes.description}>{description}</Typography> : null}

                {options.indexOf('no-cars') === -1 ? <>
                    {isMobile ? <FilterFormMobile isMobile={true} filter={filter} handleShowFilter={handleShowFilter}/> : null}
                    {showFilter ? null : <FilterSelection filter={props.filter} isMobile={isMobile}
                       sideContent={hasSelection ? sideContent : null}/>}
                    {/*{!description && data && data.getList.items.length ? <Typography
                        className={isMobile ? classes.latestOffersMobile : classes.latestOffers}>Latest Offers</Typography> : null}*/}
                    {showFilter ? null :

                        <>
                            <CarList items={data ? data.getList.items : null} loading={loading} error={error}
                             search={props.search+filter.params.searchIncrement+JSON.stringify(filter.params.filterOptions)}
                                 handleClick={props.handleClick}
                             returnRoute={window.location.pathname} listKey={3} yearCount={0} quietMode={false}
                                 otherCarsTitle={null}
                                 scrollingAutoload={false}
                                size={props.size}
                                isMobile={props.isMobile}
                                filter={filter}
                            />
                            {data ? <Pager data={data.getList} filter={filter} isMobile={isMobile}/> : null}
                            {!isMobile ? <WarmUp/> : null}
                        </>

                    }

                    {/*data && needMoreCars ? <MoreCars
                        handleClick={props.handleClick}
                        make={make}
                        exclude={data.getList.items.map(item => item.sn)}
                        returnRoute={window.location.pathname}
                        title={'Popular cars and trucks'}
                        listKey={4}
                        scrollingAutoload={true}
                        size={props.size}
                    /> : null*/}
                </> : null}

                {props.isMobile ?
                    <Support isMobile={props.isMobile} screenWidth={props.screenWidth} text="Let me help you with your search!"/>
                    : null}
            </div>
        </>
    );
}


